var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.destroy
    ? _c(
        "Box",
        _vm._b(
          {
            staticClass: "notification",
            class: [_vm.state, { show: _vm.isShow }]
          },
          "Box",
          _vm.$attrs,
          false
        ),
        [
          _vm._v(" " + _vm._s(_vm.text) + " "),
          _c(
            "span",
            { staticClass: "close", on: { click: () => (_vm.isShow = false) } },
            [_c("Icon", { attrs: { name: "times" } })],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }